import type { PageProps } from 'gatsby';
import React from 'react';

import Login from '@views/Authentication/Login';

export default function LoginPage({ params }: PageProps) {
  return <Login {...params} />;
}
